<div class="card mb-0 mt-0 widget-card stacked-widget" [attr.style]="(data?.colStyle || '') + (data?.rowStyle || '')">
  <div class="card-header stacked-widget-header">
    <div class="stacked-widget-header-inner">
      <div class="card-title d-flex flex-column stacked-widget-title-wrap">
        <h6 class="stacked-widget-title" [style.font-size]="data?.titleFontSize || '1.4rem'" [style.text-align]="data?.titleAlignment || 'center'">
          {{ data?.title }}
        </h6>
      </div>
    </div>
  </div>
  <div class="stacked-filters-row">
    <div class="stacked-header-filters">
      <div class="stacked-filter-range">
        <label class="stacked-filter-label" for="stacked-start-month-select">Month</label>
        <div class="range-controls">
          <select
            id="stacked-start-month-select"
            class="range-select"
            (change)="onMonthRangeChange('start', $event)">
            <option *ngFor="let month of getStartMonthOptions()" [value]="month.value" [selected]="month.value === startMonth">{{ month.label }}</option>
          </select>
          <span class="to-text">to</span>
          <select
            id="stacked-end-month-select"
            class="range-select"
            (change)="onMonthRangeChange('end', $event)">
            <option *ngFor="let month of getEndMonthOptions()" [value]="month.value" [selected]="month.value === endMonth">{{ month.label }}</option>
          </select>
        </div>
      </div>
      <div class="stacked-filter-range">
        <label class="stacked-filter-label" for="stacked-start-year-select">Year</label>
        <div class="range-controls">
          <select
            id="stacked-start-year-select"
            class="range-select"
            (change)="onYearRangeChange('start', $event)">
            <option *ngFor="let year of getStartYearOptions()" [value]="year" [selected]="year === startYear">{{ year }}</option>
          </select>
          <span class="to-text">to</span>
          <select
            id="stacked-end-year-select"
            class="range-select"
            (change)="onYearRangeChange('end', $event)">
            <option *ngFor="let year of getEndYearOptions()" [value]="year" [selected]="year === endYear">{{ year }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="stacked-parent-content-card">
    <div class="card-body stacked-widget-body stacked-chart-only-section">
      <div class="chart-container-wrapper stacked-chart-container" [style.height]="getChartHeight()">
        <div class="chart-area" [style.height]="getChartHeight()">
          <div #chartContainer class="chart" [style.height]="getChartHeight()"></div>

          <div class="scrollbar-track" [style.height]="getChartHeight()" *ngIf="allCategories.length > maxVisibleBars">
            <div class="scrollbar-thumb"
                 [style.height]="getScrollbarThumbHeight() + 'px'"
                 [style.top]="getScrollbarThumbTop() + 'px'"
                 (mousedown)="onScrollbarMouseDown($event)"></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="data?.tableConfig" class="stacked-table-section">
      <div class="cutoff-label stacked-cutoff-label">
        Cutoff % : {{ data?.tableConfig?.cutoffLabel || '98%' }}
      </div>
      <div class="stacked-table-wrapper">
        <app-repower-downtime-status-table [data]="data?.tableConfig"></app-repower-downtime-status-table>
      </div>
    </div>
  </div>
</div>

<!-- Info popup rendered as fixed overlay to avoid overlap with dropdowns -->
<div class="info-popup-fixed" *ngIf="popupType"
     [style.left.px]="popupX"
     [style.top.px]="popupY"
     (click)="$event.stopPropagation()">
  <div *ngIf="popupType === 'hours'">
    <p><strong>Engine uptime hours</strong> = 24 (hrs)* 30(days)* Number of Months * Engine Population</p>
  </div>
  <div *ngIf="popupType === 'percent'">
    <p><strong>Engine Unplanned Downtime %</strong> = Unplanned downtime hrs / Engine uptime hrs</p>
  </div>
</div>
